import { environment } from '../environments/environment';

export const APP_CONFIG = {
  MAIN_SERVER: `${environment.HTTP_PROTOCOL}://${environment.SITE_DOMAIN}`,
  API_SERVER: environment.API_HOSTNAME,
  API: '/v1/seller/api/',
  MEDIA_SERVER_FOLDER: '/media'
};
